const header =[
    {
        title:"Home",
        path:"/",
    },
    {
        title:"About Me",
        path:"/about",
    },
    {
       title: "Portfolio",
       path:"/portfolio",
    },
    {
        title:"Contact",
        path:"/contact",
    },

]
export { header };